import type { ReactElement } from "react";
import type { ExportFormat } from "~/helpers/grid/ssrmExport";

import { Box, Divider, Icon, Menu, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

interface GridExportFormatMenuProps {
	anchorEl: HTMLElement | null;
	extraItems?: ReactElement[];
	onClose: () => void;
	onSelect: (format: ExportFormat) => void;
	open: boolean;
}

const GridExportFormatMenu = ({ anchorEl, extraItems, onClose, onSelect, open }: GridExportFormatMenuProps) => {
	const { t } = useTranslation("common");
	return (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
			onClose={onClose}
			open={open}
			transformOrigin={{ horizontal: "center", vertical: "top" }}
		>
			<MenuItem onClick={() => onSelect("csv")}>
				<Box sx={{ alignItems: "center", display: "flex", gap: 1 }}>
					<Icon fontSize="small">download</Icon>
					{t("grid.export.downloadCsv")}
				</Box>
			</MenuItem>
			<MenuItem onClick={() => onSelect("xlsx")}>
				<Box sx={{ alignItems: "center", display: "flex", gap: 1 }}>
					<Icon fontSize="small">table_view</Icon>
					{t("grid.export.downloadExcel")}
				</Box>
			</MenuItem>
			{extraItems && extraItems.length > 0 && <Divider component="li" />}
			{extraItems}
		</Menu>
	);
};

export default GridExportFormatMenu;
